import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Solutions } from '../components/Solutions';
import { Expertise } from '../components/Expertise';
import { Brands } from '../components/Brands';
import { BrandStrip } from '../components/BrandStrip';
import { TextStrip } from '../components/TextStrip';
import { WhyNorthBridge } from '../components/WhyNorthBridge';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { mockData } from '../mockData';

export const HomePage = () => {
  return (
    <>
      <Header />
      <Hero data={mockData.hero} />
      <BrandStrip data={mockData.brands} speed={16} className="brand-strip-band--top" />
      <About data={mockData.about} />
      <TextStrip
        items={[
          'HVAC Systems',
          'Heat Pumps',
          'Renewable Energy',
          'Pool Climate Systems',
          'Engineering & Design',
          'Smart Controls',
        ]}
        speed={26}
        reverse
      />
      <Solutions data={mockData.solutions} />
      <Expertise data={mockData.expertise} />
      <Brands data={mockData.brands} />
      <WhyNorthBridge stats={mockData.stats} reasons={mockData.whyChoose} />
      <Contact />
      <Footer />
    </>
  );
};